<div class="title-row">
  <h2 mat-dialog-title class="title">Verify OTP</h2>
</div>

<mat-dialog-content class="content">

  <ng-container>
    <div class="info" *ngIf="showMaskedNumber">
      OTP sent to your registered mobile number {{maskedNumber}}
    </div>

    <form [formGroup]="otpForm">

      <div class="otp-boxes">
        <input #b1 class="otp-box" maxlength="1" [disabled]="!otpGenerated"
               [(ngModel)]="otpDigits[0]" [ngModelOptions]="{standalone: true}"
               (input)="onOtpInput(0, $event, b2)" (keydown)="onOtpKeydown(0, $event, null)">
        <input #b2 class="otp-box" maxlength="1" [disabled]="!otpGenerated"
               [(ngModel)]="otpDigits[1]" [ngModelOptions]="{standalone: true}"
               (input)="onOtpInput(1, $event, b3)" (keydown)="onOtpKeydown(1, $event, b1)">
        <input #b3 class="otp-box" maxlength="1" [disabled]="!otpGenerated"
               [(ngModel)]="otpDigits[2]" [ngModelOptions]="{standalone: true}"
               (input)="onOtpInput(2, $event, b4)" (keydown)="onOtpKeydown(2, $event, b2)">
        <input #b4 class="otp-box" maxlength="1" [disabled]="!otpGenerated"
               [(ngModel)]="otpDigits[3]" [ngModelOptions]="{standalone: true}"
               (input)="onOtpInput(3, $event, null)" (keydown)="onOtpKeydown(3, $event, b3)">
      </div>

      <div *ngIf="errorMsg" class="error">
        {{ errorMsg }}
      </div>

      <button mat-raised-button color="primary"
              class="btn"
              (click)="verifyOTP()"
              [disabled]="!allDigitsFilled || !canVerifyOTP">
        Verify
      </button>

    </form>

    <div class="resend" *ngIf="otpGenerated">
      <a (click)="resendOTP()" [class.disabled]="resendDisabled">
        Resend OTP <span *ngIf="resendDisabled">({{timer}})</span>
      </a>
    </div>
  </ng-container>
</mat-dialog-content>
